module.exports = __webpack_public_path__ + "media/assets/images/flags/je-d687bca3f80abdfbb765ac07fe0d657b.svg";